import { OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { users } from '@mep/pae-commons';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { RemoteDataComponent } from '@/components/TableFilters/components/Types/RemoteDataComponent';
import UserApiService from '@/modules/admin/services/UserApiService';

const { USER_TYPES } = users;

export const ProposalFilterOwner = ({ filter, t, applyFilter }) => {
  
  const filterProp = useMemo(() => ({
    field: 'owner',
    ...filter,
    request: UserApiService.search,
    labelKey: 'fullName',
    type: 'dynamic',
    filters: new OperatorFilter({
      type: 'AND', filters: [
        new TermFilter({ field: 'userType', value: USER_TYPES.USER }),
        new TermFilter({ field: 'verified', value: true })
      ]
    })
  }), [filter]);
  
  return (
    <RemoteDataComponent filter={filterProp} t={t} applyFilter={applyFilter}/>
  );
};

ProposalFilterOwner.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  applyFilter: PropTypes.func
};
